export default {"src":"/_next/static/media/pro-promise-service.0dc3cca3.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};